module.exports = __webpack_public_path__ + "static/media/2-square-dirty.c364a52f.svg";